module.exports = __webpack_public_path__ + "media/images/bnr_special_socialize-7c9f9be38ca2ae62504ae57694db47d4.jpg";